export class PreferencesEntry {
    constructor() {
        this.key = "";
    }
}
